import PropTypes from "prop-types";
import { Typography, Button } from "@material-ui/core";

export default function SectionTitle({
  number,
  title,
  classes,
  onClickButton,
  buttonText,
  buttonDisabled = false,
}) {
  return (
    <div className={classes.sectionTitleRow}>
      <div className={classes.sectionTitleRowLeft}>
        <div className={classes.sectionBadge}>{number}</div>
        <Typography component="h2" className={classes.sectionTitleText}>
          {title}
        </Typography>
      </div>
      {onClickButton && (
        <Button
          variant="outlined"
          color="primary"
          onClick={onClickButton}
          disabled={buttonDisabled}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
}

SectionTitle.propTypes = {
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  title: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
};
